/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserPreferencesControllerGetUserPreferencesQueryResponse, UserPreferencesControllerGetUserPreferencesPathParams, UserPreferencesControllerGetUserPreferences400, UserPreferencesControllerGetUserPreferences401, UserPreferencesControllerGetUserPreferences403, UserPreferencesControllerGetUserPreferences404 } from "../../models/userPreferencesController/UserPreferencesControllerGetUserPreferences";

function getUserPreferencesControllerGetUserPreferencesUrl(id: UserPreferencesControllerGetUserPreferencesPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/user-preferences/${id}` as const }  
  return res
}

/**
 * @description Retrieves the user's preferences. Auto-creates preferences if they don't exist.
 * @summary Get user preferences
 * {@link /api/v1/user-preferences/:id}
 */
export async function userPreferencesControllerGetUserPreferences(id: UserPreferencesControllerGetUserPreferencesPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserPreferencesControllerGetUserPreferencesQueryResponse, ResponseErrorConfig<UserPreferencesControllerGetUserPreferences400 | UserPreferencesControllerGetUserPreferences401 | UserPreferencesControllerGetUserPreferences403 | UserPreferencesControllerGetUserPreferences404>, unknown>({ method : "GET", url : getUserPreferencesControllerGetUserPreferencesUrl(id).url.toString(), ... requestConfig })  
  return res.data
}